(function () {
    function initBulletsSlider(root = document) {
        root.querySelectorAll('.product-insidesdata').forEach((wrap) => {
            const ul = wrap.querySelector('.metafield-rich_text_field ul');
            if (!ul || ul.dataset.enhanced === '1') return;
            ul.dataset.enhanced = '1';
            ul.classList.add('bullets-slider');
            const items = Array.from(ul.children).filter((el) => el.tagName === 'LI');
            items.forEach((li) => li.classList.add('bullets-slide'));
            const dots = document.createElement('div');
            dots.className = 'bullets-dots';
            items.forEach((li, i) => {
                const dot = document.createElement('button');
                dot.type = 'button';
                dot.className = 'bullets-dot';
                dot.setAttribute('aria-label', `Go to item ${i + 1}`);
                dot.addEventListener('click', () => {
                    ul.scrollTo({ left: li.offsetLeft, behavior: 'smooth' });
                });
                dots.appendChild(dot);
            });
            ul.insertAdjacentElement('afterend', dots);
            const dotButtons = Array.from(dots.children);

            function updateActive() {
                let idx = 0;
                let minDist = Infinity;
                items.forEach((li, i) => {
                    const dist = Math.abs(li.offsetLeft - ul.scrollLeft);
                    if (dist < minDist) {
                        minDist = dist;
                        idx = i;
                    }
                });
                dotButtons.forEach((btn, i) => btn.classList.toggle('is-active', i === idx));
            }
            updateActive();
            let rafId = null;
            ul.addEventListener('scroll', () => {
                if (rafId) cancelAnimationFrame(rafId);
                rafId = requestAnimationFrame(updateActive);
            });
            try {
                new ResizeObserver(() => {
                    if (rafId) cancelAnimationFrame(rafId);
                    rafId = requestAnimationFrame(updateActive);
                }).observe(ul);
            } catch (e) {
                window.addEventListener('resize', () => {
                    if (rafId) cancelAnimationFrame(rafId);
                    rafId = requestAnimationFrame(updateActive);
                });
            }
        });
    }

    function initProductInsidesSlider(container) {
        if (!container) return;

        let swiperInstance = null;

        function runSwiper() {
            if (window.innerWidth >= 1024) {
                if (swiperInstance) {
                    swiperInstance.destroy(true, true);
                    swiperInstance = null;
                }
                return;
            }

            if (swiperInstance) return;

            if (typeof Swiper === 'undefined') return;

            swiperInstance = new Swiper(container, {
                slidesPerView: 1,
                spaceBetween: 0,
                autoHeight: true,
                speed: 500,
                loop: false,
                pagination: {
                    el: container.querySelector('.swiper-pagination'),
                    clickable: true,
                }
            });
            container.dataset.swiperInitialized = 'true';
        }

        function loadAndRunSwiper() {
             if (typeof Swiper === 'undefined') {
                 if (!document.querySelector('#swiper-lib-js')) {
                    var script = document.createElement('script');
                    script.id = 'swiper-lib-js';
                    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
                    document.head.appendChild(script);

                    var style = document.createElement('link');
                    style.rel = 'stylesheet';
                    style.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
                    document.head.appendChild(style);

                    script.addEventListener('load', () => {
                        runSwiper();
                    });
                } else {
                    const existingScript = document.querySelector('#swiper-lib-js');
                    existingScript.addEventListener('load', runSwiper);
                }
            } else {
                runSwiper();
            }
        }
        
        loadAndRunSwiper();

        window.addEventListener('resize', runSwiper);
    }

    document.addEventListener('DOMContentLoaded', () => {
        initBulletsSlider();
        document.querySelectorAll('.product-insides-slider-container').forEach(initProductInsidesSlider);
    });

    document.addEventListener('shopify:section:load', (e) => {
        initBulletsSlider(e.target);
        const container = e.target.querySelector('.product-insides-slider-container');
        if (container) initProductInsidesSlider(container);
    });
})();
